import React from 'react';

import { Reviews } from '@/components/Reviews';
import { StarRating } from '@/components/StarRating';

type Props = {
  placement?: 'summary';
  configuration?: string;
  reviews: Queries.VariantPageQuery['reviews']['nodes'];
  title: string;
};

const ONLY_SHOW_SAME_CONFIGURATION_FOR = ['Stripe', 'Monster'];

const ReviewsContainer: React.FC<Props> = ({
  placement,
  configuration = '',
  reviews = [],
  title,
}) => {
  if (reviews.length === 0) {
    return null;
  }

  // Separate reviews for one-off cases: Monster & Stripe families as they have both rugs and throws
  // https://app.asana.com/0/1201823896983603/1203920149254229/f
  const localReviews = reviews.filter((review) => {
    if (ONLY_SHOW_SAME_CONFIGURATION_FOR.includes(title)) {
      // We split the configuration string by space and take the first
      // word so that we get "Rug" and not "Rug Medium", for example
      // prettier-ignore
      const variantConfig = review.variant.airtable?.product?.configuration;
      if (!variantConfig) {
        return false;
      }

      return configuration.includes(variantConfig.split(' ')[0]);
    }

    return review;
  });

  if (localReviews.length === 0) {
    return null;
  }

  if (placement === 'summary') {
    return (
      <div className="-mt-2">
        <StarRating scores={localReviews.map((score) => score.score)} />
      </div>
    );
  }

  return <Reviews reviews={localReviews} />;
};

export default ReviewsContainer;
